module.exports = __webpack_public_path__ + "img/b-play-bk.6fe3239e.svg";